import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import useGetMyEventList from 'entity/event/useGetMyEventList'
import useGetMyFranchise from 'entity/franchise/useGetMyFranchise'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import {convertEventTypeAsName} from 'shared/constant/lookup/eventType'
import {convertEventStateAsName} from 'shared/constant/lookup/eventState'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import useRoleCookie from 'shared/model/useRoleCookie'
import {ROLE_FRANCHISE_MANAGER} from 'shared/constant/lookup/role'
import NotMobileModal from 'shared/ui/NotMobileModal'
import {useState} from 'react'
import useIsMobile from 'shared/model/useIsMobile'
import SortableHeader from 'shared/ui/SortableHeader'
import TableLoading from 'shared/ui/TableLoading'

const MyEventList = () => {
	const navigate = useNavigate()

	const [myEventList, isLoading] = useGetMyEventList()
	const [roleCookie] = useRoleCookie()
	const [isModalOpen, setIsModalOpen] = useState(false)
	const isMobile = useIsMobile()

	const btnList = [
		{
			label: '생성',
			clickEvent: () =>
				isMobile ? setIsModalOpen(true) : navigate('/event/create'),
			deactive: false,
		},
	]

	const isFranchiseManager = roleCookie === ROLE_FRANCHISE_MANAGER
	const tableHeadList = [
		{label: '대회 날짜', sortKey: 'date'},
		{label: 'IDX', sortKey: 'idx'},
		{label: '대회 이름', sortKey: 'name'},
		...(isFranchiseManager
			? [{label: '매장 이름', sortKey: 'store_name'}]
			: []),
		{label: '대회 종류', sortKey: 'event_type_flag'},
		{label: '요구 프로 자격', sortKey: 'pro_grade_flag'},
		{label: '상태', sortKey: 'event_state_flag'},
		{label: '생성 날짜', sortKey: 'created_at'},
	]

	const sizeList = [
		'long',
		'short',
		'expand',
		...(isFranchiseManager ? ['medium'] : []),
		'medium',
		'long',
		'medium',
		'long',
	]

	return (
		<>
			{isModalOpen && (
				<NotMobileModal closeEvent={() => setIsModalOpen(false)} />
			)}

			<Style.Wrapper>
				<MainHeader btnList={btnList} mobileLayout='none'>
					{isFranchiseManager ? '내 매장 대회 관리' : '대회 목록'}
				</MainHeader>
				<Search placeholder='IDX, 콘테스트 이름으로 검색 가능' />

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										<SortableHeader sortKey={elem.sortKey}>
											{elem.label}
										</SortableHeader>
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{myEventList?.data?.event_list?.map((elem, index) => (
								<TStyle.TableRow
									key={elem?.idx || index}
									$odd={index % 2 === 1}
									onClick={() => navigate(`/event/${elem?.idx}/detail`)}
								>
									<TStyle.Data $size={sizeList[0]}>
										{timestampCalculator(elem?.date)}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
									{isFranchiseManager && (
										<TStyle.Data $size={sizeList[3]}>
											{elem?.store_name}
										</TStyle.Data>
									)}
									<TStyle.Data $size={sizeList[isFranchiseManager ? 4 : 3]}>
										{convertEventTypeAsName[elem?.event_type_flag]}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[isFranchiseManager ? 5 : 4]}>
										{convertProGradeAsName[elem?.pro_grade_flag]}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[isFranchiseManager ? 6 : 5]}>
										{convertEventStateAsName[elem?.event_state_flag]}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[isFranchiseManager ? 7 : 6]}>
										{timestampCalculator(elem?.created_at)}
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={myEventList?.data?.max_page} />
			</Style.Wrapper>
		</>
	)
}

export default MyEventList
